import { Avatar, type AvatarProps } from "@mantine/core";
import { getAvatarIdentity, getAvatarTypography } from "@canucci/base/people";
import { brandColorTokens } from "../theme/brandColorTokens";

export type ProfileAvatarProps = Omit<AvatarProps, "children" | "color" | "radius" | "name" | "size"> & {
  size?: number;
  name?: string | null;
  email?: string | null;
};

/** One presentation for profile photos and deterministic initial fallbacks. */
export function ProfileAvatar({ name, email, alt, size = 36, ...props }: ProfileAvatarProps) {
  const { initial, colorIndex } = getAvatarIdentity(name?.trim() || email);
  const colors = colorIndex === null ? brandColorTokens.avatarNeutral : brandColorTokens.avatarColors[colorIndex];
  return (
    <Avatar
      {...props}
      size={size}
      alt={alt ?? name ?? email ?? undefined}
      radius="50%"
      styles={{
        root: { border: 0, boxShadow: "none" },
        placeholder: {
          backgroundColor: colors.background,
          color: colors.text,
          ...getAvatarTypography(size),
        },
      }}
    >
      {initial}
    </Avatar>
  );
}
